import type { BuildingDto } from "@klantpunt/shared";
import { IconClose } from "../../app/icons";
import { ObligationSection } from "./ObligationSection";

/** `selAsset` in het gebouw: dit paneel in plaats van een asset (ook via `?gebouw=1`). */
export const BUILDING_OWNER = "gebouw";

/**
 * Onderhoud en keuringen bij het gebouw zelf, zonder asset (docs/ASSETS-MJOP.md, "Bij het gebouw"): bijvoorbeeld
 * de gevelinspectie of dakgoten reinigen. Zelfde kaarten, formulier en vastleggen als bij een asset.
 */
export function BuildingObligationsPanel({ building: b, onClose }: { building: BuildingDto; onClose: () => void }) {
  return (
    <div className="detail" role="region" aria-label="Onderhoud en keuringen bij het gebouw">
      <div className="dhead">
        <div className="row">
          <span className="code">{b.code}</span>
          <span className="chip small">Gebouw</span>
          <span className="grow" />
          <button type="button" className="btn ghost small ico" onClick={onClose} aria-label="Sluiten">
            <IconClose size={20} aria-hidden="true" />
          </button>
        </div>
        <h2 className="dtitle">Bij het gebouw</h2>
      </div>
      <div className="dbody">
        <p className="muted small">
          Onderhoud en keuringen die bij het gebouw horen en niet bij één asset, zoals de gevelinspectie of dakgoten
          reinigen.
        </p>
        <ObligationSection asset={null} buildingId={b.id} buildingLabel={`${b.code} · ${b.name}`} />
      </div>
    </div>
  );
}
